import { Controller } from 'stimulus';
import gsap from 'gsap';
import toArray from '../helpers/toArray';

class PaginateController extends Controller {
  onNext(event) {
    // Hide the next page button
    event.currentTarget.parentNode.hidden = true;

    const nextPage = this.getNextPage();

    if (!nextPage) {
      return;
    }

    this.showNextPage(nextPage);
    this.addPageNumberToUrl(nextPage.getAttribute('data-page'));
  }

  addPageNumberToUrl(pageNumber) {
    if (typeof window.history === 'undefined' || typeof window.history.replaceState !== 'function') {
      return;
    }

    const url = `${this.data.get('base-url')}?page=${pageNumber}`;

    window.history.replaceState(null, null, url);
  }

  // eslint-disable-next-line class-methods-use-this
  showNextPage(nextPage) {
    const nextPageChildren = toArray(nextPage.children);

    // Hide all children initially
    nextPageChildren.forEach((child) => {
      child.style.opacity = 0;
    });

    // Show the next page
    nextPage.classList.remove('d-none');

    // Fade the children in
    gsap.fromTo(nextPageChildren, {
      y: '15px',
      opacity: 0,
    }, {
      y: 0,
      opacity: 1,
      stagger: 0.25,
    });
  }

  getNextPage() {
    // Get all pages that are still hidden.
    const hiddenPages = this.pageTargets.filter((pageTarget) => pageTarget.classList.contains('d-none'));

    if (!hiddenPages.length) {
      return null;
    }

    return hiddenPages[0];
  }
}

PaginateController.targets = [
  'page',
];

export default PaginateController;
